var _g, _polyline, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ql-fill ql-color-label"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 4,
    y: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.817 5 6 5 6 6 6.38 6 6.817 5"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 2,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 3,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 4,
    y: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 2,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 2,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 2,
    y: 15
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.63 10 4 10 4 11 4.192 11 4.63 10"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 3,
    y: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 12,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 11,
    y: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 2,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 6,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 3,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 5,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 9,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 15,
    y: 14
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 13,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 15,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 14,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 15,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 14,
    y: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 14,
    y: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12 6.868 12 6 11.62 6 12 6.868"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 15,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 12,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 13,
    y: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.933 9 13 9 13 8 12.495 8 12.933 9"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 9,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 8,
    y: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 5,
    y: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 11,
    y: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 14,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 1,
    x: 15,
    y: 11
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "ql-stroke",
    points: "5.5 13 9 5 12.5 13"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 11.63,
    x2: 6.38,
    y1: 11,
    y2: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.82e25f0bd823d4d4fb1e7f4ab0a78ff8.svg";
export { ForwardRef as ReactComponent };